import classNames from 'classnames';
import { useEffect } from 'react';

import type { IBall } from '..';
import styles from './index.less';

interface IProps {
  ball: IBall;
  max: number;
  translate: number;
  reverse?: boolean;
  speed: number;
  handleClick: () => void;
}

const Ball = (props: IProps) => {
  const { ball, max, translate, reverse, speed, handleClick } = props;
  const { num, word, position } = ball;

  useEffect(() => {
    const animationName = `action-${num}-${position}`;

    const keyframes = !reverse
      ? `
        @keyframes ${animationName} {
          from {
            transform: rotate(${(360 * num) / max}deg) translateX(${translate}px) rotate(${
              (-360 * num) / max
            }deg);
          }
          to {
            transform: rotate(${(360 * num) / max + 360}deg) translateX(${translate}px) rotate(${
              (-360 * num) / max - 360
            }deg);
          }
        }
      `
      : `
        @keyframes ${animationName} {
          from {
            transform: rotate(${(360 * num) / max + 360}deg) translateX(${translate}px) rotate(${
              (-360 * num) / max - 360
            }deg);
          }
          to {
            transform: rotate(${(360 * num) / max}deg) translateX(${translate}px) rotate(${
              (-360 * num) / max
            }deg);
          }
        }
      `;

    const existingStyle = document.getElementById(`ball-animation-${num}-${position}`);

    if (existingStyle) {
      existingStyle.textContent = keyframes;
    } else {
      const styleEl = document.createElement('style');
      styleEl.id = `ball-animation-${num}-${position}`;
      styleEl.textContent = keyframes;
      document.head.appendChild(styleEl);
    }

    return () => {
      const styleToRemove = document.getElementById(`ball-animation-${num}-${position}`);
      if (styleToRemove && styleToRemove.parentNode) {
        styleToRemove.parentNode.removeChild(styleToRemove);
      }
    };
  }, [num, translate, reverse, max, position]);

  return (
    <div
      className={classNames(styles.baseBall, !word && styles.foggy)}
      onClick={() => handleClick()}
      style={{
        width: `${ball.width}px`,
        height: `${ball.width}px`,
        background: `url(${ball.bgUrl}) no-repeat center center / 120%`,
        top: `calc(50% - ${ball.width / 2}px)`,
        left: `calc(50% - ${ball.width / 2}px)`,
        animation: `action-${num}-${position} ${speed}s linear infinite`
      }}
    >
      {ball.icon}
      <div className="absolute bottom-0 left-[50%] translate-y-full -translate-x-1/2 text-[#756C5D] text-[12px] leading-[20px] whitespace-nowrap">
        {word}
      </div>
    </div>
  );
};

export default Ball;
